import { createFileRoute } from '@tanstack/react-router';

import { DestinationGroupContainer } from '@/features/destination-groups/containers/[destination-group-id]';

export const Route = createFileRoute('/_layout/destination-groups/$destinationGroupId')({
  component: DestinationGroupContainer,
});
